import React from 'react';
import PropTypes from 'prop-types';
import AmpTableRow from '../atoms/TableRow';
import AmpExpandedRow from '../atoms/ExpandedRow';

class ExpandableTableRow extends React.Component {
  state = {
    isExpanded: false
  }

  toggleExpanded = () => this.setState(prev => ({isExpanded: !prev.isExpanded}));

  render() {
    const {children, expandedContent, key, noRows} = this.props;
    const {isExpanded} = this.state;
    return (
      <React.Fragment key={key}>
        <AmpTableRow onClick={this.toggleExpanded}>
          {children}
        </AmpTableRow>
        {isExpanded && expandedContent && (
          <AmpExpandedRow noRows={noRows} expandedContent={expandedContent}>
            {expandedContent}
          </AmpExpandedRow>
        )}
      </React.Fragment>
    );
  }
}

ExpandableTableRow.propTypes = {
  children: PropTypes.array,
  expandedContent: PropTypes.object,
  key: PropTypes.string,
  noRows: PropTypes.number
};

export default ExpandableTableRow;
